const GUITAR_DATA = [
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Professional II Stratocaster",
    "model": "American Professional II Stratocaster",
    "year": "2020–Present",
    "country": "USA",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Professional II Stratocaster",
    "model": "American Professional II Stratocaster HSS",
    "year": "2020–Present",
    "country": "USA",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Professional II Stratocaster",
    "model": "American Professional II Stratocaster Left-Handed",
    "year": "2020–Present",
    "country": "USA",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Professional II Stratocaster",
    "model": "American Professional II Stratocaster HSS Left-Handed",
    "year": "2020–Present",
    "country": "USA",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Professional II Stratocaster",
    "model": "American Professional II Stratocaster  HH Shawbucker",
    "year": "2020–Present",
    "country": "USA",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Ultra Stratocaster",
    "model": "American Ultra Stratocaster",
    "year": "2019–Present",
    "country": "USA",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Ultra Stratocaster",
    "model": "American Ultra Stratocaster Luxe",
    "year": "2019–Present",
    "country": "USA",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Original",
    "model": "American Original '50s Stratocaster",
    "year": "2018–2020",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Original",
    "model": "American Original '60s Stratocaster",
    "year": "2018–2020",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Performer",
    "model": "American Performer Stratocaster",
    "year": "2018–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Performer",
    "model": "American Performer Stratocaster HSS",
    "year": "2018–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Player Stratocaster",
    "model": "Player Stratocaster",
    "year": "2018–Present",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Player Stratocaster",
    "model": "Player Stratocaster HSS",
    "year": "2018–Present",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Vintera series",
    "model": "Vintera '50s Stratocaster",
    "year": "2019–Present",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Vintera series",
    "model": "Vintera '60s Stratocaster",
    "year": "2019–Present",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Vintera series",
    "model": "Vintera '70s Stratocaster",
    "year": "2019–Present",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Vintera series",
    "model": "Vintera '50s Stratocaster Modified",
    "year": "2019–Present",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Vintera series",
    "model": "Vintera '60s Stratocaster Modified",
    "year": "2019–Present",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Vintera II Series",
    "model": "Vintera II '50s Stratocaster",
    "year": "2023–Present",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Vintera II Series",
    "model": "Vintera II '60s Stratocaster",
    "year": "2023–Present",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Vintera II Series",
    "model": "Vintera II '70s Stratocaster",
    "year": "2023–Present",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Vintera II Series",
    "model": "Noventa Stratocaster",
    "year": "2021–Present",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Road Worn",
    "model": "Road Worn '50s Stratocaster",
    "year": "2009–2010s",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Road Worn",
    "model": "Road Worn '60s Stratocaster",
    "year": "2009–2010s",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Vintage Reissue Stratocaster",
    "model": "American Vintage '57 Stratocaster",
    "year": "2012–2017",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Vintage Reissue Stratocaster",
    "model": "American Vintage '62 Stratocaster",
    "year": "2012–2017",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Vintage Reissue Stratocaster",
    "model": "American Vintage '65 Stratocaster",
    "year": "2012–2017",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Vintage II Series",
    "model": "American Vintage II 1954 Stratocaster",
    "year": "2022–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Vintage II Series",
    "model": "American Vintage II 1957 Stratocaster",
    "year": "2022–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Vintage II Series",
    "model": "American Vintage II 1961 Stratocaster",
    "year": "2022–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Vintage II Series",
    "model": "American Vintage II 1965 Stratocaster",
    "year": "2022–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Vintage II Series",
    "model": "American Vintage II 1973 Stratocaster",
    "year": "2022–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Special Stratocaster",
    "model": "American Special Stratocaster",
    "year": "2010–2018",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "American Special Stratocaster",
    "model": "American Special Stratocaster HSS",
    "year": "2010–2018",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Eric Clapton Stratocaster",
    "year": "1988–Present",
    "country": "USA/Japan/Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Stevie Ray Vaughan Stratocaster",
    "year": "1992–Present",
    "country": "USA/Japan/Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "Left-handed model",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Yngwie Malmsteen Stratocaster",
    "year": "1998–Present",
    "country": "USA/Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Jeff Beck Stratocaster",
    "year": "2001–Present",
    "country": "USA",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Eric Johnson Stratocaster",
    "year": "2005–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Ritchie Blackmore Stratocaster",
    "year": "2007–Present",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Jimmie Vaughan Stratocaster",
    "year": "2008–Present",
    "country": "USA/Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "David Gilmour Stratocaster",
    "year": "2009–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Mark Knopfler Stratocaster",
    "year": "2010–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Buddy Guy Stratocaster",
    "year": "2012–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Robert Cray Stratocaster",
    "year": "2013–Present",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Cory Wong Stratocaster",
    "year": "2021–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "H.E.R. Stratocaster",
    "year": "2021–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "George Fullerton Stratocaster",
    "year": "2015–Present",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Rory Gallagher Stratocaster",
    "year": "2017–Present",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Tyler Bryant Stratocaster",
    "year": "2018–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Tom Morello Stratocaster",
    "year": "2020–Present",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Jimi Hendrix Stratocaster",
    "year": "1990s–Present",
    "country": "USA/Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "John Mayer Stratocaster",
    "year": "2005–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Dick Dale Stratocaster",
    "year": "1990s–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Bonnie Raitt Stratocaster",
    "year": "1990s–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Richie Kotzen Stratocaster",
    "year": "2010s–Present",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Mary Kaye Stratocaster",
    "year": "1990s–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Pete Townshend Stratocaster",
    "year": "2000s–Present",
    "country": "USA",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Robin Trower Stratocaster",
    "year": "2000s–Present",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Nile Rodgers Stratocaster",
    "year": "2010s–Present",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Signature models",
    "model": "Ed O'Brien Stratocaster",
    "year": "2010s–Present",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "57 Vintage Stratocaster \"Squier Series\" (JV)",
    "year": "4/1982-Summer 1982",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "62 Vintage Stratocaster \"Squier Series\" (JV)",
    "year": "4/1982-Summer 1982",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Squier '57 Vintage Stratocaster (JV)",
    "year": "Summer 1982-10/1984",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Squier '62 Vintage Stratocaster (JV)",
    "year": "Summer 1982-10/1984",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Squier Stratocaster (SQ)",
    "year": "Late 1983-1984",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Squier Standard Stratocaster",
    "year": "Late 1984-1988",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Standard Stratocaster (Model #1)",
    "year": "1985-10/1987",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Contemporary Stratocaster",
    "year": "1985-1988",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Contemporary Deluxe Stratocaster",
    "year": "1985-1987",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Squier Contemporary Stratocaster",
    "year": "1985-8/1988",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Standard Stratocaster (Model #2)",
    "year": "3/1987-12/1987",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "68 Stratocaster",
    "year": "Late 1987-Early 1999",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Paisley Stratocaster (Model #1)",
    "year": "10/1987-12/1989; 1993-1995",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Squier Standard Stratocaster with FS1 Locking Tremolo",
    "year": "1987-1988",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Blue Flower Stratocaster (Model #1)",
    "year": "10/1988-12/1989",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "H.M. Strat",
    "year": "4/1988-6/1989",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Stratocaster XII (Model #1)",
    "year": "1/1988-Mid 1991",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Standard Stratocaster (Model #3)",
    "year": "1/1988-10/1989",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Standard Stratocaster (Model #4)",
    "year": "10/1988-12/1990",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Standard Stratocaster (Less Tremolo Model)",
    "year": "1/1988-6/1990",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "50's Stratocaster",
    "year": "11/1989-12/1998",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "60's Stratocaster",
    "year": "11/1989-12/1998",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "HRR '50s Stratocaster",
    "year": "7/1990-1993",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "HRR '60s Stratocaster",
    "year": "7/1990-1993",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Yngwie Malmsteen Standard Stratocaster",
    "year": "7/1990-12/1994",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Squier Silver Series Stratocaster/SST-33",
    "year": "1990-1996",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "H.M. Strat",
    "year": "1991-8/1992",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Squier Hank Marvin Stratocaster",
    "year": "1991-1993",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "72 Stratocaster",
    "year": "2/1992-Mid 1996",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Squier Series Stratocaster",
    "year": "~1992-1995",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Wayne's World Stratocaster",
    "year": "1992-1993",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Foto Flame Floyd Rose Stratocaster",
    "year": "9/1992-6/1996",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Strat XII (Model #2)",
    "year": "1/1994-12/1996",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Standard Stratocaster (ST-460R & ST-460M models)",
    "year": "~1994-1995",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "60's Stratocaster Natural",
    "year": "3/1994-12/1994",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Foto Flame Stratocaster",
    "year": "1/1995-12/1996",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Hank Marvin Stratocaster",
    "year": "1/1996-1997",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Richie Sambora Black Paisley Stratocaster",
    "year": "1/1996-12/1996",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "The Ventures Stratocaster",
    "year": "1/1996-12/1996",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Jerry Donhaue Stratocaster",
    "year": "1/1997-12/1998",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "John Jorgenson Hellecaster",
    "year": "1/1997-12/1998",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Ritchie Blackmore Stratocaster",
    "year": "1/1997-12/1997",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Matthias Jabs Stratocaster",
    "year": "1/1998-12/1998",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Iron Maiden Stratocaster",
    "year": "7/2001-12/2001",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Paisley Stratocaster (Model #2)",
    "year": "1/2002-12/2003; 7/2008",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Blue Flower Stratocaster (Model #2)",
    "year": "1/2002-12/2003; 7/2008",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Antigua Stratocaster",
    "year": "6/2003-12/2003",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Aerodyne Stratocaster (Model #1)",
    "year": "2004.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Aerodyne Stratocaster (Model #2)",
    "year": "2005-2006",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Stratocaster 12-String (Model #3)",
    "year": "2005-2009",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Aerodyne Classic Stratocaster",
    "year": "7/2006-12/2009",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "FSR LTD Edition '58 Stratocaster",
    "year": "2013-02-01 00:00:00",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "FSR Flip Flop Stratocaster HSS",
    "year": "2014.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "FSR Classic Stratocaster 3-Tone Sunburst Gold Hardware",
    "year": "4/2015-8/2017",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Made in Japan Exclusive Aerodyne Strat",
    "year": "12/2016-2018",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Made in Japan Exclusive Aerodyne Stratocaster HSS",
    "year": "12/2016-2018",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "FSR Made in Japan Exclusive Classic Special '54 Stratocaster",
    "year": "2017-2018",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Traditional '60s Stratocaster",
    "year": "2017-Present",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Traditional '50s Stratocaster",
    "year": "2017-Present",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Hybrid II Stratocaster",
    "year": "2018-Present",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Hybrid II Stratocaster HSS",
    "year": "2018-Present",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "FSR Traditional '50s Stratocaster with Stripe",
    "year": "2018.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "FSR Traditional '60s Midnight Stratocaster",
    "year": "2018.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "FSR Traditional Stratocaster XII",
    "year": "2018.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "FSR Limited Edition Aerodyne Stratocaster",
    "year": "2018.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Made in Japan Limited Collection '50s Stratocaster White Blonde",
    "year": "2018.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Limited Edition Aerodyne Classic Stratocaster Flame Maple Top",
    "year": "2019.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Hybrid Stratocaster Indigo",
    "year": "2019.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Limited Edition Traditional '60s Stratocaster Daybreak",
    "year": "2019.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Made in Japan Limited Collection Stratocaster White Blonde",
    "year": "2019.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Limited Edition HM Strat",
    "year": "2020.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Limited Edition Black Paisley Stratocaster",
    "year": "2020.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Boxer Series Stratocaster HH",
    "year": "2020.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Final Fantasy XIV Stratocaster",
    "year": "2021.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "JV Modified '50s Stratocaster HSS",
    "year": "2022.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "JV Modified '60s Stratocaster",
    "year": "2022.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Aerodyne Special Stratocaster",
    "year": "2022.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Aerodyne Special Stratocaster HSS",
    "year": "2022.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Made in Japan Limited International Color Stratocaster",
    "year": "2022.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Made in Japan Limited Hybrid II Stratocaster, Noir Model",
    "year": "2022.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Made in Japan Hybrid II Stratocaster HSS",
    "year": "2023.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Made in Japan Traditional Stratocaster Limited Run Reverse Head",
    "year": "2023.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "2024 Collection Made in Japan Hybrid II Stratocaster HSS",
    "year": "2024.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "2024 Collection Made in Japan Hybrid II Stratocaster HSH",
    "year": "2024.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Made in Japan \"Export and domestic models\"",
    "model": "Made in Japan Traditional second series",
    "year": "2024.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Stratocaster",
    "year": "1991.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/standard-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Squier Classic Stratocaster",
    "year": "1993.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-stratocaster-mexico.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Floyd Rose Squier Series Stratocaster",
    "year": "1993.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/floyd-rose-squier-series-stratocaster-mexico.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Guitar Center 29th Anniversary Stratocaster",
    "year": "1993.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/guitar-center-29th-anniversary-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Squier Series Standard Stratocaster",
    "year": "1994.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-series-stratocaster-mexico.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Floyd Rose Standard Stratocaster",
    "year": "1994.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/floyd-rose-standard-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Richie Sambora Standard Stratocaster",
    "year": "1994.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/richie-sambora-stratocaster-mexico.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Strat Special",
    "year": "1994.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/strat-special-mexico.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Wayne's World 2 Stratocaster",
    "year": "1994.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/wayne-world-2-stratocaster-mexico.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Sam Ash Sunset Boulevard Stratocaster",
    "year": "1995.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/sunset-boulevard-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Tex-Mex Strat",
    "year": "1996.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/tex-mex-strat.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Traditional Stratocaster",
    "year": "1996.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/traditional-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Traditional Fat Stratocaster",
    "year": "1996.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/traditional-fat-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "California Stratocaster",
    "year": "1997.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/california-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "California Fat Stratocaster",
    "year": "1997.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/california-fat-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Powerhouse Stratocaster",
    "year": "1997.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/deluxe-powerhouse-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Deluxe Super Strat",
    "year": "1997.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/deluxe-super-strat.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Jimmie Vaughan Tex-Mex Strat",
    "year": "1997.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/jimmie-vaughan-tex-mex-strat.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Tex-Mex Strat Special",
    "year": "1997.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/tex-mex-strat-special.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Deluxe Fat Strat HSS Floyd Rose",
    "year": "1998.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/deluxe-strat-hss-floyd-rose.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Deluxe Double Fat Strat HH Floyd Rose",
    "year": "1998.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/deluxe-strat-hh-floyd-rose.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Roland Ready Stratocaster",
    "year": "1998.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/standard-roland-ready-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Squier Standard Stratocaster",
    "year": "1998.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-stratocaster-mim.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Squier Standard Fat Strat",
    "year": "1998.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-standard-fat-strat-mexico.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Squier Standard Fat Strat Floyd Rose",
    "year": "1998.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-standard-fat-strat-floyd-rose-mexico.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Deluxe Fat Strat HSS",
    "year": "1999.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/deluxe-strat-hss.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Deluxe Double Fat Strat HH",
    "year": "1999.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/deluxe-strat-hh.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Chris Rea Classic Stratocaster",
    "year": "1999.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/chris-rea-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "50s Stratocaster",
    "year": "1999.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/50s-classic-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "60s Stratocaster",
    "year": "1999.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/60s-classic-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "70s Stratocaster",
    "year": "1999.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/70s-classic-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Strat HSS",
    "year": "1999.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/standard-strat-hss.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Strat HSS with Locking Tremolo",
    "year": "1999.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/standard-strat-hss-locking-tremolo.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Hank Marvin Classic Stratocaster",
    "year": "2000.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/hank-marvin-stratocaster-mexico.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Tom Delonge Stratocaster",
    "year": "2001.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/tom-delonge-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Vintage Player '50s Stratocaster",
    "year": "2001.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/50s-vintage-player-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Vintage Player '60s Stratocaster",
    "year": "2001.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/60s-vintage-player-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Buddy Guy Standard Stratocaster",
    "year": "2002.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/buddy-guy-stratocaster-polka-dot.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "FMT Standard Stratocaster",
    "year": "2002.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/2002-mim-fmt-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "FSR Trans Moto Standard Stratocaster",
    "year": "2002.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/2002-trans-moto-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Robert Cray Standard Stratocaster",
    "year": "2003.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/robert-cray-made-in-mexico-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Splatter Stratocaster",
    "year": "2003.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/splatter-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Stratocaster Satin",
    "year": "2003.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/standard-stratocaster-satin.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Acoustasonic Strat",
    "year": "2003.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/acoustasonic-strat.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "FSR Powerhouse Stratocaster",
    "year": "2003.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/fsr-powerhouse-stratocaster.html#google_vignette"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Stratocaster FSR (Hot Rod Flame)",
    "year": "",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/2003-hot-rod-flame-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "50th Anniversary Golden Stratocaster",
    "year": "2004.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/50th-anniversary-golden-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Deluxe Players Strat",
    "year": "2004.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/deluxe-players-strat.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Strat HH",
    "year": "2004.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/standard-strat-hh.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Stratocaster Junior",
    "year": "2004.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/stratocaster-junior.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "FSR Standard Stratocaster Natural",
    "year": "2004.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/fsr-standard-stratocaster-natural.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "FRS FMT Standard Stratocaster",
    "year": "2004.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/2004-frs-fmt-standard-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Limited Edition Flip Flop Green Blue Standard Stratocaster",
    "year": "2004.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/flip-flop-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "FSR Standard Fat Strat Turned Pickguard",
    "year": "2004.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/2005-fsr-standard-fat-strat.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "FSR Standard Stratocaster FMT",
    "year": "2005.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/fmt-standard-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Limited Edition HSS Gold Sister Stratocaster",
    "year": "2005.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/gold-sister-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Limited Edition HSS Silver Sister Stratocaster",
    "year": "2005.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/silver-sister-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Big Block Stratocaster",
    "year": "2005.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/big-block-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Classic Player '50s Stratocaster",
    "year": "2006.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/50s-classic-player-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Classic Player '60s Stratocaster",
    "year": "2006.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/60s-classic-player-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Deluxe Power Stratocaster",
    "year": "2006.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/deluxe-power-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "60th Anniversary Standard Stratocaster",
    "year": "2006.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/2006-60th-anniversary-stratocaster-mexico.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Lone Star Stratocaster",
    "year": "2007.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/lone-star-stratocaster-mim.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Roadhouse Stratocaster",
    "year": "2007.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/roadhouse-stratocaster-mim.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Stratocaster (Upgrade)",
    "year": "2008.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/standard-stratocaster-upgrade.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Strat HSS (Upgrade)",
    "year": "2008.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/standard-strat-hss-upgrade.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Strat HSS with Locking Tremolo (Upgrade)",
    "year": "2008.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/standard-strat-hss-locking-tremolo-upgrade.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Roland Ready Stratocaster (Upgrade)",
    "year": "2008.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/standard-roland-ready-stratocaster-upgrade.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Kenny Wayne Shepherd Stratocaster",
    "year": "2008.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/kenny-wayne-shepherd-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Ritchie Blackmore Stratocaster",
    "year": "2009.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/ritchie-blackmore-stratocaster-mexico.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Road Worn '50s Stratocaster",
    "year": "2009.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/road-worn-50-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Road Worn '60s Stratocaster",
    "year": "2009.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/road-worn-60-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Blacktop Stratocaster HH",
    "year": "2010.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/blacktop-hh-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "FSR Standard Strat HSS Flake",
    "year": "2010.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/fsr-standard-strat-hss-flake.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "FSR Standard Stratocaster HH Metallic 3-Tone Sunburst",
    "year": "2010.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/2010-fsr-standard-stratocaster-hh-metallic-sunburst.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Wayne Kramer Signature Strat",
    "year": "2011.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/wayne-kramer-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Road Worn Player Stratocaster",
    "year": "2011.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/road-worn-player-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Road Worn Player Stratocaster HSS",
    "year": "2011.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/road-worn-player-stratocaster-hss.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Blacktop Strat HH Floyd Rose",
    "year": "2011.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/blacktop-hh-stratocaster-floyd-rose.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Blacktop Stratocaster HSH",
    "year": "2012.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/blacktop-hsh-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Black Paisley Stratocaster HSS",
    "year": "2012.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/2012-black-paisley-stratocaster-hss.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "50s Stratocaster Lacquer",
    "year": "2013.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/50s-lacquer-classic-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "60s Stratocaster Lacquer",
    "year": "2013.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/60s-lacquer-classic-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Stratocaster Satin (Special Edition)",
    "year": "2013.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/standard-stratocaster-satin-special-edition.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Stratocaster Plus Top",
    "year": "2013.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/plus-top-standard-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Stratocaster HSS Plus Top",
    "year": "2013.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/plus-top-standard-stratocaster-hss.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Stratocaster Plus Top with Locking Tremolo",
    "year": "2013.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/plus-top-standard-stratocaster-floyd.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Stratocaster HSS Swirl",
    "year": "2013.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/standard-stratocaster-swirl-special-edition.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Pawn Shop '70s Stratocaster Deluxe",
    "year": "2013.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/pawn-shop-70-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "60th Anniversary Classic Player '50s Stratocaster",
    "year": "2014.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/2014-60th-anniversary-classic-player-50-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Deluxe Lone Star Stratocaster (Upgrade)",
    "year": "2014.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/deluxe-lone-star-stratocaster-mim.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Deluxe Roadhouse Stratocaster (Upgrade 1)",
    "year": "2014.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/deluxe-roadhouse-stratocaster-mim.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Fender Fishman TriplePlay Stratocaster HSS",
    "year": "2014.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/fishman-tripleplay-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Deluxe Stratocaster HSS Plus Top with iOS Connectivity",
    "year": "2014.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/deluxe-stratocaster-plus-top-ios-connettivity.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Stratocaster HH (Upgrade)",
    "year": "2015.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/standard-stratocaster-hh-upgrade.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Stratocaster HSH",
    "year": "2015.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/standard-stratocaster-hsh.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Standard Stratocaster HSS with Floyd Rose",
    "year": "2015.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/standard-stratocaster-hss-floyd-rose.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Jimi Hendrix Stratocaster",
    "year": "2015.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/jimi-hendrix-stratocaster-mim.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Dave Murray California Stratocaster",
    "year": "2015.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/dave-murray-stratocaster-mim.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Classic Player Strat HH",
    "year": "2015.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/classic-player-strat-hh.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Special Edition David Lozeau Art Stratocaster",
    "year": "2015.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/special-edition-david-lozeau-art-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Deluxe Strat",
    "year": "2016.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/deluxe-strat.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Deluxe Strat HSS",
    "year": "2016.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/deluxe-strat-hss-2016.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "White Opal Sparkle Standard Stratocaster",
    "year": "2016.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/white-opal-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Jimi Hendrix Monterey Stratocaster",
    "year": "2017.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/hendrix-monterey-strat-mexico.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Ed O'Brien Sustainer Stratocaster",
    "year": "2017.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/eob-sustainer-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Deluxe Roadhouse Stratocaster (Upgrade 2)",
    "year": "2017.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/deluxe-roadhouse-strat-mim.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "FSR Stratocaster Noir HSS",
    "year": "2017.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/fsr-stratocaster-noir-hss.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Player Stratocaster",
    "year": "2018.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/player-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Player Stratocaster HSS",
    "year": "2018.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/player-stratocaster-hss.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Player Stratocaster HSH",
    "year": "2018.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/player-stratocaster-hsh.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Player Stratocaster Plus Top",
    "year": "2018.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/player-stratocaster-plus-top.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Player Stratocaster HSS Plus Top",
    "year": "2018.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/player-stratocaster-plus-top-hss.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Player Stratocaster Floyd Rose HSS",
    "year": "2018.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/player-stratocaster-floyd-rose-hss.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Albert Hammond Jr. Stratocaster",
    "year": "2018.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/albert-hammond-jr-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Limited Edition Mahogany Blacktop Stratocaster",
    "year": "2019.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/limited-edition-mahogany-blacktop-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Vintera '50s Stratocaster",
    "year": "2019.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/50s-vintera-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Vintera '60s Stratocaster",
    "year": "2019.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/60s-vintera-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Vintera '70s Stratocaster",
    "year": "2019.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/70s-vintera-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Vintera '50s Stratocaster Modified",
    "year": "2019.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/50s-vintera-modified-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Vintera '60s Stratocaster Modified",
    "year": "2019.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/60s-vintera-modified-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Tyler the Creator Stratocaster",
    "year": "2019.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/tyler-the-creator-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Tom Morello Stratocaster",
    "year": "2020.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/tom-morello-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "H.E.R. Stratocaster",
    "year": "2020.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/her-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Tash Sultana Stratocaster",
    "year": "2020.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/tash-sultana-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Vintera Road Worn '50s Stratocaster",
    "year": "2020.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/50s-vintera-road-worn-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Vintera Road Worn '60s Stratocaster",
    "year": "2020.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/60s-vintera-road-worn-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "75th Anniversary Stratocaster",
    "year": "2021.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/2021-75th-anniversary-stratocaster-mexico.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Noventa Stratocaster",
    "year": "2021.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/noventa-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Player Plus Stratocaster",
    "year": "2021.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/player-plus-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Player Plus Stratocaster HSS",
    "year": "2021.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/player-plus-stratocaster-hss.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "30th Anniversary Screamadelica Stratocaster",
    "year": "2021.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/screamadelica-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Limited Edition Vintera '50s Stratocaster HSS Road Worn",
    "year": "2021.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/50s-vintera-stratocaster-hss-road-worn.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "FSR Vintera Road Worn '60s Stratocaster",
    "year": "2021.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/fsr-60s-vintera-road-worn-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "FSR Vintera Road Worn '60s Mischief Maker Stratocaster",
    "year": "2021.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/vintera-road-worn-mischief-maker-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "George Harrison Rocky Stratocaster",
    "year": "2022.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/george-harrison-rocky-stratocaster-mexico.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Steve Lacy People Pleaser Stratocaster",
    "year": "2023.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/steve-lacy-people-pleaser-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Limited Edition Tom DeLonge Stratocaster",
    "year": "2023.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/tom-delonge-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Mike McCready Stratocaster",
    "year": "2023.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/mike-mccready-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Vintera II '50s Stratocaster",
    "year": "2023.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/50s-vintera-ii-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Vintera II '60s Stratocaster",
    "year": "2023.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/60s-vintera-ii-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Vintera II '70s Stratocaster",
    "year": "2023.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/70s-vintera-ii-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Limited Edition Vintera Road Worn '50s Stratocaster",
    "year": "2023.0",
    "country": "Mexico",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/limited-50s-vintera-road-worn-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "70th Anniversary Player Stratocaster",
    "year": "2024.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/2024-70th-anniversary-player-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "70th Anniversary Vintera II Antigua Stratocaster",
    "year": "2024.0",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/2024-70th-anniversary-vintera-ii-antigua-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Player II Stratocaster",
    "year": "2024.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/player-ii-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Mexican Stratocasters",
    "model": "Player II Stratocaster HSS",
    "year": "2024.0",
    "country": "Mexico",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/player-ii-stratocaster-hss.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Fender Stratocaster",
    "year": "1987.0",
    "country": "Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/fender-stratocaster-korea.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier Standard Stratocaster - Squier Standard Series",
    "year": "1987.0",
    "country": "Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-stratocaster-korea.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier Contemporary Stratocaster - Squier Contemporary Series",
    "year": "1988.0",
    "country": "Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/contemporary-stratocaster-korea.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier II Standard Stratocaster - Made in Korea & India",
    "year": "1988.0",
    "country": "India",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-ii-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier II Standard Stratocaster HSS - Made in India",
    "year": "1988.0",
    "country": "India",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-ii-stratocaster-hss.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier II Contemporary Stratocaster - Made in Korea",
    "year": "1988.0",
    "country": "Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-ii-stratocaster-contemporary.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier HM I Strat - Squier HM Series",
    "year": "1989.0",
    "country": "Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-hm-i.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier HM II Strat - Squier HM Series",
    "year": "1989.0",
    "country": "Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-hm-ii.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier HM III Strat - Squier HM Series",
    "year": "1989.0",
    "country": "Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-hm-iii.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier Bullet Stratocaster (Model #1) - Bullet Series",
    "year": "1989.0",
    "country": "Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-bullet-korea-1989.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier HM IV Strat - Squier HM Series",
    "year": "1990.0",
    "country": "Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-hm-iv.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier HM V Strat - Squier HM Series",
    "year": "1990.0",
    "country": "Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-hm-v.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier Standard Stratocaster - Squier Standard Series",
    "year": "1992.0",
    "country": "Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-stratocaster-korea-m2.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier Standard Stratocaster - Squier Standard Series",
    "year": "1992.0",
    "country": "Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-stratocaster-korea-1992.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier Contemporary Stratocaster - Squier Contemporary Series",
    "year": "1992.0",
    "country": "Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/contemporary-m2-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier Contemporary Stratocaster - Squier Contemporary Series",
    "year": "1992.0",
    "country": "Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/1992-contemporary-stratocaster-korea.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Fender Squier Series Stratocaster - Squier Series",
    "year": "1992.0",
    "country": "Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-series-stratocaster-korea.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier Standard Stratocaster - Squier Standard Series",
    "year": "1994.0",
    "country": "Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-stratocaster-korea-1995.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier Bullet Stratocaster (Model #2) - Bullet Series",
    "year": "1994.0",
    "country": "Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-bullet-korea.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier Standard Stratocaster - Squier Standard Series",
    "year": "1996.0",
    "country": "Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-standard-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier Standard Fat Stratocaster - Squier Standard Series",
    "year": "1996.0",
    "country": "Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-standard-fat-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier Pro Tone Stratocaster - Pro Tone Series",
    "year": "1996.0",
    "country": "Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/pro-tone-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier Pro Tone Fat Strat - Pro Tone Series",
    "year": "1996.0",
    "country": "Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/pro-tone-fat-strat.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier California Series Strat (SSS and HSS Models)",
    "year": "2003.0",
    "country": "China/India",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/squier-california-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Fender Lite Ash Stratocaster - Special Edition Series",
    "year": "2004.0",
    "country": "Korea",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/lite-ash-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Fender Tie-Dye Strat HS (also known as “Tie-Dye Showmaster”) – Special Edition Series",
    "year": "2004.0",
    "country": "Korea",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/tie-dye-strat.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Fender So-Cal Speed Shop Guitar - Special Edition Series",
    "year": "2005.0",
    "country": "Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/so-cal-speed-shop-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Fender Rockford Fosgate 25th Anniversary Stratocaster - Special Edition Series",
    "year": "2005.0",
    "country": "Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/rockford-fosgate-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Fender Koa Stratocaster - Special Edition Series",
    "year": "2006.0",
    "country": "Korea",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/special-edition-koa-stratocaster.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier Vintage Modified Strat - India",
    "year": "2007.0",
    "country": "India",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/vintage-modified-strat-india.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Stratocaster",
    "series": "Korea & India made models",
    "model": "Squier Vintage Modified Strat HSS - India",
    "year": "2007.0",
    "country": "India",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": "",
    "reference_url": "https://www.fuzzfaced.net/vintage-modified-strat-hss-india.html"
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "Chris Shiflett Cleaver Telecaster Deluxe",
    "year": "Unknown",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "Jack White Triplecaster Telecaster",
    "year": "Unknown",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "Susan Tedeschi Telecaster",
    "year": "Unknown",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "unverified",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "Buck Owens Telecaster",
    "year": "Unknown",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "Jim Root Telecaster",
    "year": "2010",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "John 5 Telecaster",
    "year": "2003",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "Brad Paisley Road Worn Telecaster",
    "year": "2017",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "Richie Kotzen Telecaster",
    "year": "1995",
    "country": "Japan",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "James Burton Telecaster",
    "year": "1990",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "Jimmy Page Telecaster",
    "year": "2019",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "J Mascis Telecaster",
    "year": "2021",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "George Harrison Telecaster",
    "year": "2017",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "Albert Collins Telecaster",
    "year": "1990",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "Danny Gatton Telecaster",
    "year": "1991",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "Merle Haggard Telecaster",
    "year": "1997",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "Will Ray Jazz-a-Caster",
    "year": "1997",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "Robben Ford Telecaster",
    "year": "1987",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "Andy Summers Telecaster",
    "year": "2007",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "unverified",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Artist Signature",
    "model": "G.E. Smith Telecaster",
    "year": "2007",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Limited Edition",
    "model": "Limited Edition American Performer Timber Telecaster",
    "year": "Unknown",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Limited Edition",
    "model": "Limited Edition Cabronita Telecaster",
    "year": "2012",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Limited Edition",
    "model": "Limited Edition American Professional II Cabronita Telecaster® HH",
    "year": "2020",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Limited Edition",
    "model": "Limited Edition Parallel Universe Volume II Tele Mágico",
    "year": "2020",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Acoustasonic® Player",
    "model": "Acoustasonic Player Telecaster",
    "year": "2021",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Aerodyne®",
    "model": "Aerodyne Special Telecaster",
    "year": "2021",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Acoustasonic®",
    "model": "American Acoustasonic Telecaster",
    "year": "2019",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Performer",
    "model": "American Performer Telecaster",
    "year": "2018",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Performer",
    "model": "American Performer Telecaster Hum",
    "year": "2018",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Professional II",
    "model": "American Professional II Telecaster",
    "year": "2020",
    "country": "USA",
    "compatible_model": "VT2ND Modern",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Ultra",
    "model": "American Ultra Telecaster",
    "year": "2019",
    "country": "USA",
    "compatible_model": "VT2ND Modern",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Ultra",
    "model": "American Ultra Telecaster Left-Hand",
    "year": "2019",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Ultra II",
    "model": "American Ultra II Telecaster",
    "year": "2023",
    "country": "USA",
    "compatible_model": "VT2ND Modern",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Vintage II",
    "model": "American Vintage II 1951 Telecaster",
    "year": "2022",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Vintage II",
    "model": "American Vintage II 1952 Telecaster",
    "year": "2022",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Vintage II",
    "model": "American Vintage II 1963 Telecaster",
    "year": "2022",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Gold Foil",
    "model": "Gold Foil Telecaster",
    "year": "2023",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Player",
    "model": "Player Telecaster",
    "year": "2018",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Player",
    "model": "Player Telecaster HH",
    "year": "2018",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Player II",
    "model": "Player II Telecaster",
    "year": "2023",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Player Plus",
    "model": "Player Plus Telecaster",
    "year": "2021",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "unverified",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Broadcaster",
    "model": "Broadcaster",
    "year": "1950-1951",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Nocaster",
    "model": "Nocaster",
    "year": "1951.0",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Esquire",
    "model": "Esquire",
    "year": "1950-present",
    "country": "USA (various locations)",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster",
    "model": "Telecaster",
    "year": "1951-present",
    "country": "USA (various locations)",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Thinline",
    "model": "Telecaster Thinline",
    "year": "1968-present",
    "country": "USA (various locations)",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Thinline",
    "model": "American Professional II Thinline",
    "year": "2020 - Present",
    "country": "USA",
    "compatible_model": "VT2ND Modern",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Thinline",
    "model": "American Vintage II 1972 Thinline",
    "year": "2022 - Present",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Thinline",
    "model": "Vintera II '70s Thinline",
    "year": "2023 - Present",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Thinline",
    "model": "Jim Adkins JA-90 Thinline",
    "year": "2007 - Present",
    "country": "Indonesia (formerly Korea)",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Thinline",
    "model": "Britt Daniel Tele Thinline",
    "year": "2023 - Present",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Thinline",
    "model": "Limited Edition American Professional II Thinline",
    "year": "",
    "country": "USA",
    "compatible_model": "VT2ND Modern",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Thinline",
    "model": "Limited Edition Suona Telecaster Thinline",
    "year": "",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Thinline",
    "model": "Classic Series Thinline",
    "year": "",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Custom",
    "model": "1968–1972 Telecaster Custom (Original)",
    "year": "1968–1972",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Custom",
    "model": "1972 Telecaster Custom Reissue (Japanese)",
    "year": "1972 (Reissue)",
    "country": "Japan",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Custom",
    "model": "Telecaster Custom (Modern Player Series)",
    "year": "2010s",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Custom",
    "model": "Telecaster Custom (Fender Japan Exclusive)",
    "year": "1980s–Present",
    "country": "Japan",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Custom",
    "model": "Telecaster Custom (Fender American Vintage)",
    "year": "2012–2017",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Custom",
    "model": "Telecaster Custom (Fender Classic Series)",
    "year": "2000s–Present",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Custom",
    "model": "Telecaster Custom (Fender Parallel Universe)",
    "year": "2018–Present",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Custom",
    "model": "Telecaster Custom (Fender Custom Shop)",
    "year": "1990s–Present",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Custom",
    "model": "Telecaster Custom (Squier Classic Vibe)",
    "year": "2000s–Present",
    "country": "China/Indonesia",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Telecaster Deluxe",
    "model": "Telecaster Deluxe",
    "year": "1973-present",
    "country": "USA (various locations)",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Vintage Series",
    "model": "American Vintage Series",
    "year": "1982-2017",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "TL-52",
    "model": "TL-52",
    "year": "1982-2015",
    "country": "Japan",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Elite Telecaster",
    "model": "Elite Telecaster",
    "year": "1983-1984",
    "country": "USA",
    "compatible_model": "VT2ND Modern",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Standard Telecaster",
    "model": "American Standard Telecaster",
    "year": "1988-2016",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Standard Series",
    "model": "Standard Series",
    "year": "1988-2018",
    "country": "Mexico, Japan, China, Korea",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Deluxe Series",
    "model": "Deluxe Series",
    "year": "1998-2020",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Deluxe Series",
    "model": "American Deluxe Telecaster HH",
    "year": "2000–2016",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Deluxe Series",
    "model": "American Deluxe Telecaster Ash",
    "year": "2000–2016",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Deluxe Series",
    "model": "American Deluxe Telecaster Maple Fingerboard",
    "year": "2000–2016",
    "country": "USA",
    "compatible_model": "VT2ND Modern",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Deluxe Series",
    "model": "American Deluxe Telecaster Rosewood Fingerboard",
    "year": "2000–2016",
    "country": "USA",
    "compatible_model": "VT2ND Modern",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Deluxe Series",
    "model": "American Deluxe Telecaster Nashville",
    "year": "2000–2016",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Deluxe Series",
    "model": "American Deluxe Telecaster Limited Edition",
    "year": "2000–2016",
    "country": "USA",
    "compatible_model": "VT2ND Modern",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Classic Series",
    "model": "Classic Series '50s Telecaster",
    "year": "1998-2018",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Classic Series",
    "model": "Classic Series '60s Telecaster",
    "year": "1998-2018",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Classic Series",
    "model": "Classic Series '70s Telecaster Custom",
    "year": "1998-2018",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Classic Series",
    "model": "Classic Series '70s Telecaster Deluxe",
    "year": "1998-2018",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Classic Series",
    "model": "Classic Series '50s Telecaster Esquire",
    "year": "1998-2018",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Vintage Hot Rod Series",
    "model": "Vintage Hot Rod '52 Telecaster",
    "year": "2000s-2010s",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Vintage Hot Rod Series",
    "model": "Vintage Hot Rod '62 Telecaster",
    "year": "2000s-2010s",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Road Worn Series",
    "model": "Road Worn '50s Telecaster",
    "year": "2009–2010s",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Road Worn Series",
    "model": "Road Worn '60s Telecaster",
    "year": "2009–2010s",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Professional Series",
    "model": "American Professional Telecaster",
    "year": "2017–2020",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Professional Series",
    "model": "American Professional Telecaster HH",
    "year": "2017–2020",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Professional Series",
    "model": "American Professional Telecaster Deluxe",
    "year": "2017–2020",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Original Series",
    "model": "American Original '50s Telecaster",
    "year": "2018–2020",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Original Series",
    "model": "American Original '60s Telecaster",
    "year": "2018–2020",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Performer Series",
    "model": "American Performer Telecaster",
    "year": "2018–Present",
    "country": "USA",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Performer Series",
    "model": "American Performer Telecaster Hum",
    "year": "2018–Present",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Player Series",
    "model": "Player Telecaster",
    "year": "2018–Present",
    "country": "Mexico",
    "compatible_model": "VT2ND Modern",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Player Series",
    "model": "Player Telecaster HH",
    "year": "2018–Present",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Vintera Series",
    "model": "Vintera '50s Telecaster",
    "year": "2019–Present",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Vintera Series",
    "model": "Vintera '60s Telecaster",
    "year": "2019–Present",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Vintera Series",
    "model": "Vintera '50s Telecaster Modified",
    "year": "2019–Present",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Vintera Series",
    "model": "Vintera '60s Telecaster Modified",
    "year": "2019–Present",
    "country": "Mexico",
    "compatible_model": "VT2ND Classic",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Ultra Telecaster",
    "model": "American Ultra Telecaster",
    "year": "2019–Present",
    "country": "USA",
    "compatible_model": "VT2ND Modern",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "American Ultra Telecaster",
    "model": "American Ultra Telecaster Luxe",
    "year": "2019–Present",
    "country": "USA",
    "compatible_model": "VT2ND Modern",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Noventa Telecaster",
    "model": "Noventa Telecaster",
    "year": "2021-present",
    "country": "Mexico",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Fender Player II Strat",
    "model": "Fender Player II Strat RW BCG",
    "year": "2024.0",
    "country": "Ensenada, México",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Fender",
    "guitar_type": "Telecaster",
    "series": "Strat Ultra 2",
    "model": "Strat Ultra 2",
    "year": "2025.0",
    "country": "Corona, California",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "AZ",
    "model": "AZ2402",
    "year": "2018-Present",
    "country": "Japan (Prestige)",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "AZ",
    "model": "AZ2204",
    "year": "2018-Present",
    "country": "Japan (Prestige)",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "AZ",
    "model": "AZ2407",
    "year": "2019-Present",
    "country": "Japan (Prestige)",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "AZ",
    "model": "AZS2200",
    "year": "2020-Present",
    "country": "Japan (Prestige)",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "AZ",
    "model": "AZ2204N",
    "year": "2020-Present",
    "country": "Japan (Prestige)",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "AZ",
    "model": "AZ242F",
    "year": "2019-Present",
    "country": "Japan (Prestige)",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "AZ",
    "model": "AZ242PBG",
    "year": "2018-Present",
    "country": "Indonesia (Premium)",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "AZ",
    "model": "AZ2204N",
    "year": "2019-Present",
    "country": "Indonesia (Premium)",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "AZ",
    "model": "AZ226PB",
    "year": "2019-Present",
    "country": "Indonesia (Premium)",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "AZ",
    "model": "AZ24027",
    "year": "2020-Present",
    "country": "Indonesia (Premium)",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "AZ",
    "model": "AZES40",
    "year": "2021-Present",
    "country": "Indonesia (Essentials)",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "AZ",
    "model": "AZES31",
    "year": "2021-Present",
    "country": "Indonesia (Essentials)",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar Series",
    "model": "RS100,",
    "year": "Early 80's,",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar Series",
    "model": "RS300,",
    "year": "Early 80's,",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar Series",
    "model": "RS300L",
    "year": "Early 80's,",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar Series",
    "model": "RS500,",
    "year": "Early 80's,",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar Series",
    "model": "RS800,",
    "year": "Early 80's,",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "AH10 (Alan Holdsworth)",
    "year": "1985–1987",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "AH20 (Alan Holdsworth)",
    "year": "1985–1987",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG120",
    "year": "1986-1987",
    "country": "Japan / Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG135",
    "year": "1986-1987",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG140",
    "year": "1986-1987",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG240",
    "year": "1987.0",
    "country": "Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG250",
    "year": "1987.0",
    "country": "Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG340",
    "year": "1987.0",
    "country": "Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG404",
    "year": "1987.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG410",
    "year": "1986-1987",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG420",
    "year": "1986-1987",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG425",
    "year": "1986.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG430",
    "year": "1986-1987",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG440",
    "year": "1986-1987",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG440 (24frets)",
    "year": "1986.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG441",
    "year": "1987.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG450",
    "year": "1986.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG525",
    "year": "1986.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG530",
    "year": "1986.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG531",
    "year": "1987.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG550",
    "year": "1987-1994",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG600",
    "year": "1986.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG650",
    "year": "1986.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG652",
    "year": "1986-1987",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG1003",
    "year": "1986-1987",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG1200",
    "year": "1986-1987",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": "Edge trem"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG50",
    "year": "1986.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG52",
    "year": "1986.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG53",
    "year": "1986.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG110",
    "year": "1986.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RG200",
    "year": "1986-1987",
    "country": "Japan/Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS110",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS135",
    "year": "1983-1985",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS140",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS230",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS240",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS320",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS400",
    "year": "1983-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS410",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS420",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS430",
    "year": "1984-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS440",
    "year": "1984-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS450",
    "year": "1983-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS520",
    "year": "1984-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS525",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS528",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS529",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS530",
    "year": "1984-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS1300",
    "year": "1984-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS5200",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS5250",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS111",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS121",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS136",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS141",
    "year": "1985.0",
    "country": "japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS1010SL (Steve Lukather)",
    "year": "1983-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS100",
    "year": "1983-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS125",
    "year": "1983-1984",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS130",
    "year": "1984.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS205",
    "year": "1983-1984",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS225",
    "year": "1984.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS400",
    "year": "1983-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS315",
    "year": "1983-1984",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS405",
    "year": "1983-1984",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS430",
    "year": "1984-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS440",
    "year": "1984-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS450",
    "year": "1983-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS505",
    "year": "1983-1984",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS520",
    "year": "1984-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS530",
    "year": "1984-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS1000",
    "year": "1983-1984",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS1100",
    "year": "1983-1984",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS1300",
    "year": "1984-1985",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS1400",
    "year": "1983-1984",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS1500",
    "year": "1983-1984",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Roadstar II Series",
    "model": "RS135",
    "year": "1983-1985",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Joe Satriani",
    "year": "1989-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Steve Vai",
    "year": "1987-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Paul Gilbert",
    "year": "1990-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "John Petrucci",
    "year": "2001-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Mick Thomson",
    "year": "2008-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Nita Strauss",
    "year": "2019-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Kiko Loureiro",
    "year": "2017-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Herman Li",
    "year": "2010-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Paul Stanley",
    "year": "2009-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Andy Timmons",
    "year": "2005-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Tosin Abasi",
    "year": "2014-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Jake Bowen",
    "year": "2013-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Tim Henson",
    "year": "2021-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Scott LePage",
    "year": "2021-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Tom Quayle",
    "year": "2020-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Ichika Nito",
    "year": "2021-Present",
    "country": "Japan/Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Cesareo models",
    "year": "2006/2007",
    "country": "Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "E-Gen models",
    "year": "2008–2019",
    "country": "Japan/Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Erick Hansel models",
    "year": "2019–2024",
    "country": "Japan/Indonesia",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Frank Gambale models",
    "year": "1991–1993",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Ichika Nito models",
    "year": "2023–2025",
    "country": "Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Jay Yuenger models",
    "year": "1996–1999",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Nita Strauss",
    "year": "2018-Present",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Josh Smith models",
    "year": "2021–2025",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": "VT2 Modern"
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Lari Basilio models",
    "year": "2021–2025",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Luca Mantovanelli models",
    "year": "2023–2025",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Marco Sfogli models",
    "year": "2016–2018",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Mario Camarena models",
    "year": "2019–2024",
    "country": "Indonesia",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Martin Miller models",
    "year": "2023–2025",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Mick Thomson models",
    "year": "2006–2011",
    "country": "Korea/Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Patrick Rondat models",
    "year": "2007.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Paul Gilbert models",
    "year": "1995–2003",
    "country": "Japan/Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Paul Waggoner models",
    "year": "2016–2020",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "PIA models",
    "year": "2023; 2025",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Reb Beach models",
    "year": "1991–1993",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Vinnie Moore models",
    "year": "1988–1989",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "Yvette Young models",
    "year": "2020–2025",
    "country": "Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Ibanez Signature Guitars",
    "model": "KMM1",
    "year": "2010–2011",
    "country": "China",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL100 (1995)",
    "year": "1995.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL1025",
    "year": "1997–1998",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL150",
    "year": "1996.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL240",
    "year": "1997–1998",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL300 (1995)",
    "year": "1995.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL300ZB",
    "year": "1996.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL350",
    "year": "1981-1982",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL440",
    "year": "1997–1998",
    "country": "Korea",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL450",
    "year": "1981–1982",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL470",
    "year": "1981–1982",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL50",
    "year": "1981.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL500 (1981–1982)",
    "year": "",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL500 (1995)",
    "year": "1995.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL540",
    "year": "1997.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL550",
    "year": "1981–1982",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL70",
    "year": "1981.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL825",
    "year": "1998.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL840",
    "year": "1997.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "Blazer series",
    "model": "BL850",
    "year": "1997.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX120SP",
    "year": "2022–2025",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX140 (2003–2004)",
    "year": "2003–2004",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX140 (2006–2017)",
    "year": "2003–2004",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX140 (2018)",
    "year": "2018.0",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX150 (2006–2017)",
    "year": "2006–2017",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX150 (2018–2019)",
    "year": "2018–2019",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX150 (2021)",
    "year": "2021.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX170",
    "year": "2003.0",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX20",
    "year": "2000–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX20DX",
    "year": "2011–2014",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX20EXB",
    "year": "2019–2020",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX20L",
    "year": "2000–2011",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX20W",
    "year": "2014–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX22",
    "year": "2000–2018",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX22EX",
    "year": "2019–2020",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX22EXL",
    "year": "2019–2020",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX40",
    "year": "2000–2025",
    "country": "China / Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX50",
    "year": "2014–2018",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX55",
    "year": "2014–2015",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX55B",
    "year": "2015–2019",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX60",
    "year": "2013–2014",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX6SP1",
    "year": "2021.0",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX6SP1 (2016–2019)",
    "year": "2016–2019",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX70",
    "year": "2000–2003",
    "country": "China / Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX70DX",
    "year": "2008–2012",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX70QA",
    "year": "2011–2025",
    "country": "China / Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX70QAL",
    "year": "2012–2025",
    "country": "China / Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX720",
    "year": "2001–2004",
    "country": "China / Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX90",
    "year": "2021.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "GRX90 (2001–2017)",
    "year": "2001–2017",
    "country": "China / Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX150 (1994–1995, alder body)",
    "year": "1994–1995",
    "country": "South Korea",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX150 (1995–1996, resoncast body)",
    "year": "1995–1996",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX160",
    "year": "1994.0",
    "country": "South Korea",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX170 (1994–1995, rosewood fretboard)",
    "year": "1994–1995",
    "country": "South Korea",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX170 (1994–1996, maple fretboard)",
    "year": "1994–1996",
    "country": "South Korea",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX170 (1999)",
    "year": "1999.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX170B",
    "year": "1994–1995",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX170D",
    "year": "1996–1997",
    "country": "Korea",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX175B",
    "year": "1998.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX180B",
    "year": "1997–1998",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX180G",
    "year": "1999–2000",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX180GQ",
    "year": "1994–1995",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX185GQ",
    "year": "1996.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX20",
    "year": "1994–1998",
    "country": "Korea, Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX20L",
    "year": "1994–1999",
    "country": "Korea, Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX240",
    "year": "1996–1997",
    "country": "South Korea",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX270",
    "year": "1994.0",
    "country": "South Korea",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX350",
    "year": "1994–1995",
    "country": "South Korea",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX352",
    "year": "1994.0",
    "country": "South Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX370B",
    "year": "1994.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX40 (1994–1995)",
    "year": "1994.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX40 (1996–1997)",
    "year": "1996–1997",
    "country": "Korea, Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX60",
    "year": "1995–1996",
    "country": "South Korea",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX650",
    "year": "1994–1995",
    "country": "South Korea",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX670",
    "year": "1994.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RX Series",
    "model": "RX750",
    "year": "1994.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG010LTD",
    "year": "2010–2011",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG06LTD",
    "year": "2006.0",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG07LTD1",
    "year": "2007.0",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG07LTD2",
    "year": "2007.0",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG120BDX",
    "year": "2012–2016",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG120EX",
    "year": "2010–2012",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG120QASP",
    "year": "2021–2025",
    "country": "China",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG120QH",
    "year": "2019–2020",
    "country": "China",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG120ZW",
    "year": "2018–2019",
    "country": "China",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG121",
    "year": "2006–2009",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG121DX",
    "year": "2012–2025",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG121EX (2006–2011)",
    "year": "2006–2011",
    "country": "China /indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG121EX (2015–2018)",
    "year": "2015–2018",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG121EXS",
    "year": "2016.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG121EXSM",
    "year": "2017–2018",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG121PAR",
    "year": "2023–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG121SP",
    "year": "2022–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG121SP (2015)",
    "year": "2015.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG131DX",
    "year": "2018–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG140",
    "year": "2012–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG150",
    "year": "2005–2010; 2013–2015",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG150B",
    "year": "2015–2018",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG150DX",
    "year": "2008–2022",
    "country": "China / Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG150DXB",
    "year": "2011–2016",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG150DXP",
    "year": "2017.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG150LTD",
    "year": "2015–2016",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG150P (2011–2017)",
    "year": "2011–2017",
    "country": "China / Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG150P (2018–2019)",
    "year": "2018–2019",
    "country": "China",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG150P (2021)",
    "year": "2021.0",
    "country": "China",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG150QA (2013–2016)",
    "year": "2013–2016",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG150QA (2017–2019)",
    "year": "2018–2019",
    "country": "China",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG150QA (2021–2022)",
    "year": "2021–2022",
    "country": "China",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG170",
    "year": "2004–2005",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG170BBW",
    "year": "2015–2017",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG170BSW",
    "year": "2015–2017",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG170DX",
    "year": "2004–2025",
    "country": "China / Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG170DXB (2014–2019)",
    "year": "2014–2019",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG170DXB (2021–2022)",
    "year": "2021–2022",
    "country": "China",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG170DXFM",
    "year": "2008–2009",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG170DXL",
    "year": "2008–2010",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG170M",
    "year": "2009.0",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG180",
    "year": "2004–2005",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG20Z",
    "year": "2013–2017",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG220DEX",
    "year": "2007–2009",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG220PA",
    "year": "2022.0",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG220PA1",
    "year": "2023–2025",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG250B",
    "year": "2015–2017",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG250DX",
    "year": "2009–2015",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG250DXB",
    "year": "2012–2014",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG250M (2014–2017)",
    "year": "2014–2017",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG250M (2018)",
    "year": "2018.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG250P (2009–2018)",
    "year": "2009–2018",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG250P (2021–2022)",
    "year": "2021–2022",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG255DX (2016–2019)",
    "year": "2016–2019",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG255DX (2021–2022)",
    "year": "2021–2022",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG270 (2003–2018)",
    "year": "2003–2018",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG270 (2021–2022)",
    "year": "2021—2022",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG270B",
    "year": "2004–2014",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG270DX",
    "year": "2003–2010, 2016–2017",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG270DXB",
    "year": "2012–2014",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG270DXBL",
    "year": "2012–2015",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG270DXFM",
    "year": "2006–2010",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG320FA",
    "year": "2024–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG370FM",
    "year": "2003–2005",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG6SP1",
    "year": "2018–2019",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG70QA",
    "year": "2014–2015",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG7221",
    "year": "2013–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG7221M",
    "year": "2018–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG7221QA",
    "year": "2019–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG7221QA (2014–2015)",
    "year": "2014–2015",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRG7321EX",
    "year": "2016.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGA012",
    "year": "2012.0",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGA11",
    "year": "2010.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGA120",
    "year": "2016–2025",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGA120QA",
    "year": "2019–2025",
    "country": "China",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGA21",
    "year": "2011–2013",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGA22",
    "year": "2010.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGA22FM",
    "year": "2010–2013",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGA32",
    "year": "2010–2013",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGA32EX",
    "year": "2011.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGA32T",
    "year": "2010–2011",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGA42QA",
    "year": "2011–2015",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGA42T",
    "year": "2010–2011",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGA42TQA",
    "year": "2011–2015",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGM08LTD1",
    "year": "2008.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGM08LTD2",
    "year": "2008.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGM08LTD3",
    "year": "2008.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGM09LTD1",
    "year": "2009.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGM09LTD2",
    "year": "2009.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGM21",
    "year": "2006–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGM21CT1",
    "year": "2014.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGM21CT2",
    "year": "2014.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGM21L",
    "year": "2014.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGM21M",
    "year": "2009–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGM21MCT",
    "year": "2013.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGM21MSP",
    "year": "2012.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGM21N",
    "year": "2019–2020",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGM22QA",
    "year": "2017–2019",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGM51HP",
    "year": "2017–2019",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGR010LTD",
    "year": "2010.0",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGR011LTD",
    "year": "2011.0",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGR09LTD",
    "year": "2009.0",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGR120EX",
    "year": "2017–2019",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGR121EX",
    "year": "2009–2015",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGR121M",
    "year": "2013–2016",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGR131EX",
    "year": "2021–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGR220M",
    "year": "2015.0",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGR221PA",
    "year": "2021–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGR330EX",
    "year": "2024–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGS22",
    "year": "2009–2010",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRGS22FM",
    "year": "2009–2010",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX120SP",
    "year": "2022–2025",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX140 (2003–2004)",
    "year": "2003–2004",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX140 (2006–2017)",
    "year": "2006–2017",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX140 (2018)",
    "year": "2018.0",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX150 (2006–2017)",
    "year": "2006–2017",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX150 (2018–2019)",
    "year": "2018–2019",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX150 (2021)",
    "year": "2021.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX170",
    "year": "2003.0",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX170L",
    "year": "2003.0",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX20",
    "year": "2000–2025",
    "country": "China / Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX20DX",
    "year": "2011–2014",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX20EXB",
    "year": "2019–2020",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX20L",
    "year": "2000–2011",
    "country": "China / Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX20W",
    "year": "2014–2025",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX22",
    "year": "2000–2018",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX22EX",
    "year": "2019–2020",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX22EXL",
    "year": "2019–2020",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX40",
    "year": "2000–2025",
    "country": "China / Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX45",
    "year": "2000–2002",
    "country": "Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX50",
    "year": "2014–2018",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX55",
    "year": "2014–2015",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX55B",
    "year": "2015–2019",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX60",
    "year": "2013–2014",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX6SP1",
    "year": "2021.0",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX6SP1 (2016–2019)",
    "year": "2016–2019",
    "country": "China",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX70",
    "year": "2000–2003",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX70DX",
    "year": "2008–2012",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX70L",
    "year": "2008–2012",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX70QA",
    "year": "2011–2025",
    "country": "China / Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX70QAL",
    "year": "2011–2025",
    "country": "China / Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX720",
    "year": "2001–2004",
    "country": "China / Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX90",
    "year": "2021.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GRX90 (2001–2017)",
    "year": "2001–2017",
    "country": "China / Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GS121",
    "year": "2013–2014",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GS221",
    "year": "2014–2016",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GS270",
    "year": "2015–2016",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GS370DX",
    "year": "2016–2017",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GS6SP1",
    "year": "2016–2017",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GSA06LTD",
    "year": "2006.0",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GSA20",
    "year": "2000–2004",
    "country": "Korea",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GSA220FM",
    "year": "2006.0",
    "country": "Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GSA26",
    "year": "2012.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GSA270",
    "year": "2003.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GSA270DX",
    "year": "2003.0",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GSA370QM",
    "year": "2003–2004",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GSA6",
    "year": "2005–2011",
    "country": "China / Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GSA60",
    "year": "2000–2025",
    "country": "China / Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GSA60QA",
    "year": "2022.0",
    "country": "China",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GSA6M",
    "year": "2009.0",
    "country": "China / Indonesia",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "GIO series",
    "model": "GSAS26FM",
    "year": "2009–2010",
    "country": "China",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RGV Series",
    "model": "RGV250",
    "year": "2021–2025",
    "country": "Indonesia",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RGV Series",
    "model": "RGV3750BD",
    "year": "2016–2017",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RGV Series",
    "model": "RGV3750D",
    "year": "2016–2017",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RGV Series",
    "model": "RGV8570",
    "year": "2018.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RT Series",
    "model": "RT140",
    "year": "1992.0",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RT Series",
    "model": "RT150",
    "year": "1992–1993",
    "country": "Japan",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RT Series",
    "model": "RT240",
    "year": "1992–1993",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RT Series",
    "model": "RT250",
    "year": "1993.0",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RT Series",
    "model": "RT450",
    "year": "1992–1993",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RT Series",
    "model": "RT452",
    "year": "1993.0",
    "country": "Japan",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Ibanez",
    "guitar_type": "Strat-style",
    "series": "RT Series",
    "model": "RT650GF",
    "year": "1992–1993",
    "country": "Japan",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Custom",
    "model": "Custom 24",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Custom",
    "model": "Custom 24-08",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Custom",
    "model": "Custom 24 Piezo",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Custom",
    "model": "Custom 24 \"Floyd\"",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Custom",
    "model": "40th Anniversary Custom 24 Limited Edition",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Custom",
    "model": "40th Anniversary Custom 24-08 Semi-Hollow Limited Edition",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Custom",
    "model": "McCarty",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Custom",
    "model": "McCarty - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Custom",
    "model": "McCarty 594 - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Custom",
    "model": "McCarty 594 Hollowbody II - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Standard",
    "model": "Standard  24 Satin",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Standard",
    "model": "CE",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Standard",
    "model": "CE 24 - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Standard",
    "model": "CE 24 Semi-Hollow - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Standard",
    "model": "CE 24-08 Black Limba Limited Edition - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Standard",
    "model": "CE 24-08 Swamp Ash Limited Edition - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Hollowbody",
    "model": "McCarty 594 Hollowbody II - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Hollowbody",
    "model": "Hollowbody II Piezo - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Signature",
    "model": "DGT - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Signature",
    "model": "DGT Semi-Hollow Limited Edition - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Signature",
    "model": "Mark Tremonti Signature - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Signature",
    "model": "Santana Retro - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Signature",
    "model": "Kanami Limited Edition",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Signature",
    "model": "Silver Sky - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Signature",
    "model": "Silver Sky Maple - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Signature",
    "model": "Fiore - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Signature",
    "model": "Fiore Satin - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Signature",
    "model": "Myles Kennedy - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Specialty",
    "model": "Special Semi-Hollow - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Specialty",
    "model": "Studio - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Specialty",
    "model": "Modern Eagle V - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Specialty",
    "model": "Swamp Ash Special - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "Specialty",
    "model": "Swamp Ash Special Maple - 2025",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "SE Series",
    "model": "SE CE 24 - 2025",
    "year": "",
    "country": "Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "SE Series",
    "model": "SE CE 24 Standard Satin - 2025",
    "year": "",
    "country": "Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "PRS",
    "guitar_type": "Strat-style",
    "series": "SE Series",
    "model": "SE Swamp Ash CE 24 \"Sandblasted\" Limited Edition",
    "year": "",
    "country": "Indonesia",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Artist Guitars",
    "model": "John Petrucci",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "Luke 4 SSS | Guitars | Ernie Ball Music Man",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "Luke 4 HH | Guitars | Ernie Ball Music Man",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "Steve Morse",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "Rabea Massaad",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "James Valentine",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "Dustin Kensrue",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "Kaizen",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "Jason Richardson",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "New Releases",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "StingRay II Deluxe",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "StingRay II",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "Valentine",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "10th Anniversary Majesty",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "Kaizen Gallium",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "Sabre",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "Sabre HT",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "Cutlass RS HSS",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "Axis",
    "year": "",
    "country": "USA",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "AxisSuperSport",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "Silhouette",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Music Man",
    "guitar_type": "Strat-style",
    "series": "Steve Lukather",
    "model": "Silhouette Special",
    "year": "",
    "country": "USA",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "PAC012/100 Series",
    "model": "PAC112V",
    "year": "2025.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "PAC012/100 Series",
    "model": "PAC112VM",
    "year": "2025.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "PAC012/100 Series",
    "model": "PAC120H",
    "year": "2025.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "PAC012/100 Series",
    "model": "PAC112J",
    "year": "2025.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "PAC012/100 Series",
    "model": "PAC012",
    "year": "2025.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "PAC200 Series",
    "model": "PAC212VQM",
    "year": "2025.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "PAC200 Series",
    "model": "PAC212VFM",
    "year": "2025.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "PAC300 Series",
    "model": "PAC311H",
    "year": "2025.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "PAC600 Series",
    "model": "PAC612VIIFMX",
    "year": "2025.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "PAC600 Series",
    "model": "PAC612VIIX",
    "year": "2025.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "PAC600 Series",
    "model": "PAC611VFM",
    "year": "2025.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "PAC600 Series",
    "model": "PAC611HFM",
    "year": "2025.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "PAC600 Series",
    "model": "PAC611H",
    "year": "2025.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Pacifica Standard Plus",
    "model": "PACS+12",
    "year": "2025.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Pacifica Standard Plus",
    "model": "PACS+12M",
    "year": "2025.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Pacifica Professional",
    "model": "PACP12",
    "year": "2025.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Pacifica Professional",
    "model": "PACP12M",
    "year": "2025.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "SR-400",
    "year": "1976.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "SR-500",
    "year": "1976.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "SE-300",
    "year": "1985.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "VX",
    "year": "1985.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "STH-400",
    "year": "80's",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "SE150",
    "year": "80's",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "RGX110",
    "year": "1987.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "SE110",
    "year": "1987.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Session II",
    "year": "1987.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "RGX112",
    "year": "1988.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 1412",
    "year": "1990.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 1421",
    "year": "1990.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 912",
    "year": "1990.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 921",
    "year": "1990.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 712",
    "year": "1990.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 721",
    "year": "1990.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 1221",
    "year": "1990.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 1221M",
    "year": "1990.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 1221MS",
    "year": "1990.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 1230S",
    "year": "1990.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "YG1221-MR",
    "year": "1992.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "YG821-DMR",
    "year": "1992.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "YG821-D",
    "year": "1992.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "YG621-MR",
    "year": "1992.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "YG521-MR",
    "year": "1992.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "YG820-DR",
    "year": "1992.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "YG1212",
    "year": "1992.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "YG1221",
    "year": "1992.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "YG612",
    "year": "1992.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "YG621",
    "year": "1992.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "YG512",
    "year": "1992.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "YG521",
    "year": "1992.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MG11R",
    "year": "1989.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MGK",
    "year": "1989.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MG111M",
    "year": "1989.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MG Standard",
    "year": "1989.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MG11RS – Special edition",
    "year": "1989.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MG111RS – Special edition",
    "year": "1989.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MG1C –",
    "year": "1989.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 904",
    "year": "1994.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 604",
    "year": "1994.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 112",
    "year": "1994.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 912J",
    "year": "1994.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 621",
    "year": "1994.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "820R (Blues Saraceno sig)",
    "year": "1994.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "621D",
    "year": "1994.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "421D",
    "year": "1994.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "321FP",
    "year": "1994.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "121FP",
    "year": "1994.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "120D",
    "year": "1994.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "121D",
    "year": "1994.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "YGX-121FP",
    "year": "1995.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "YGS-112 T",
    "year": "1995.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica Custom",
    "year": "1996.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 904",
    "year": "1996.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 904M",
    "year": "1996.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 904SF",
    "year": "1996.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 904MSF",
    "year": "1996.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 721J",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 721JH",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 721DH",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 604W",
    "year": "1996.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 604WH",
    "year": "1996.0",
    "country": "",
    "compatible_model": "VT1 2-Point",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 312",
    "year": "1996.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 112",
    "year": "1996.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "Pacifica 312H",
    "year": "1996.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "RGX821D",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "RGX821DMR",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "RGX521D",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "RGX521DM",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "RGX221DH",
    "year": "1996.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "RGX121D",
    "year": "1996.0",
    "country": "",
    "compatible_model": "VT1 Standard",
    "compatibility_status": "compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MG Standard",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "not_compatible",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MGII RS",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MGKII",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MG-HK",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MG-IIS",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MGM Custom",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MGM III",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MGM II G",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  },
  {
    "brand": "Yamaha",
    "guitar_type": "Strat-style",
    "series": "Vintage models",
    "model": "MGM II",
    "year": "1996.0",
    "country": "",
    "compatible_model": "",
    "compatibility_status": "unknown",
    "notes": ""
  }
];